import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import PublicationLinks from "../../Publications/components/PublicationLinks";
import helpers from "../../../common/utils/utils";

const variantAnnotationUrl = "https://www.pharmgkb.org/variantAnnotation/";
const chemicalUrl = "https://www.pharmgkb.org/chemical/";

export const getChemicalRelationsTableMobile = (items) => {
  const result = (
    <div>
      <Expander showMore="2">
        {items.map((item, key) => {
          const pDynamic =
            item.pharmacodynamic !== undefined &&
            item.pharmacodynamic !== null &&
            (item.pharmacodynamic ? "Yes" : "No");
          const pKinetic =
            item.pharmacokinetic !== undefined &&
            item.pharmacokinetic !== null &&
            (item.pharmacokinetic ? "Yes" : "No");
          const sign =
            item.significant !== undefined &&
            item.significant !== null &&
            (item.significant ? "Yes" : "No");
          const k = `dl-${key}`;
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={k}>
              <span>
                <dt className="col-12 col-xs-12">Drug</dt>
                <dd className="col-12 col-xs-12">
                  {item.id && item.name ? (
                    <a
                      href={getVarsoUrl(chemicalUrl + item.id)}
                      target="_blank"
                    >
                      {(item.name &&
                        helpers.capitalizeFirstLetter(
                          item.name.toLowerCase()
                        )) ||
                        "-"}
                    </a>
                  ) : (
                    item.name || "-"
                  )}
                </dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Association</dt>
                <dd className="col-12 col-xs-12">
                  {(item.association &&
                    helpers.capitalizeFirstLetter(
                      item.association.toLowerCase()
                    )) ||
                    "-"}
                </dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Significant</dt>
                <dd className="col-12 col-xs-12">{sign || "-"}</dd>
              </span>
              {item.drug_variant_relation && (
                <span>
                  <dt className="col-12 col-xs-12">Drug Variant Relation</dt>
                  <dd className="col-12 col-xs-12">
                    {(item.drug_variant_relation &&
                      helpers.capitalizeFirstLetter(
                        item.drug_variant_relation.toLowerCase()
                      )) ||
                      "-"}
                  </dd>
                </span>
              )}
              <span>
                <dt className="col-12 col-xs-12">Pharmacodynamic</dt>
                <dd className="col-12 col-xs-12">{pDynamic || "-"}</dd>
              </span>

              <span>
                <dt className="col-12 col-xs-12">Pharmacokinetic</dt>
                <dd className="col-12 col-xs-12">{pKinetic || "-"}</dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Publications</dt>
                <dd className="col-12 col-xs-12">
                  {item.pub_med_references ? (
                    <PublicationLinks ids={item.pub_med_references} />
                  ) : (
                    "-"
                  )}
                </dd>
              </span>
              {item.annotation_id && (
                <span>
                  <dt className="col-12 col-xs-12">Annotation ID</dt>
                  <dd className="col-12 col-xs-12">
                    <a
                      href={getVarsoUrl(
                        variantAnnotationUrl + item.annotation_id
                      )}
                      target="_blank"
                    >
                      {item.annotation_id}
                    </a>
                  </dd>
                </span>
              )}
              {item.curator_notes && (
                <span>
                  <dt className="col-12 col-xs-12">Curator notes</dt>
                  <dd className="col-12 col-xs-12">{item.curator_notes}</dd>
                </span>
              )}
            </dl>
          );
        })}
      </Expander>
    </div>
  );
  return result;
};
